import { render, staticRenderFns } from "./HeaderPanel.vue?vue&type=template&id=523001e0&"
import script from "./HeaderPanel.vue?vue&type=script&lang=ts&"
export * from "./HeaderPanel.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports